import styled from "styled-components";
import LogoSVG from "../../../assets/images/logo";

const NavWrapper = styled.nav`
  z-index: 80;
  &.hermes_header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    margin-top: 1px;
    height: 90px;
    transition: all 0.3s;

    &.sticky {
      position: fixed;
      top: 0;
      width: 100%;
      background: rgba(27, 34, 38, 0.8);
      backdrop-filter: blur(15px);
      z-index: 81;
      margin-top: 0px;
      transition: all 0.2s;
    }
  }

  .hermes_menu_sect {
    height: 90px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .hermes_menu_left_sect {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 15%;

    .logo {
      a {
        display: inline-block;
      }
    }
  }

  .hermes_menu_right_sect {
    width: 85%;
    display: flex;
    align-items: center;
    justify-content: end;
  }

  .hermes_menu_list {
    margin-left: 65px;
    margin-right: 96px;
    max-width: 514px;
    min-width: 409px;
    width: 100%;
    ul {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0;
      padding: 0;

      li {
        position: relative;
        cursor: pointer;

        a {
          font-family: "Bakbak One";
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 22px;
          text-align: center;
          text-transform: uppercase;
          color: #ffffff;
        }

        &:hover {
          a {
            color: var(--primary-color);
          }
        }

        /* submenu */
        &.submenu {
          .sub_menu_sect {
            background: transparent;
            border-top: 50px solid transparent;
            position: absolute;
            top: -50px;
            left: -20px;
            width: 190px;
            visibility: hidden;
            opacity: 0;
            z-index: -100;
            transition: all 0.5s;

            .sub_menu_list {
              padding: 15px 20px;
              background: #171f25;
              flex-wrap: wrap;
              li {
                a {
                  font-family: "Bakbak One";
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  line-height: 40px;
                  color: rgba(255, 255, 255, 0.8);
                  text-transform: capitalize;
                }

                &:hover {
                  a {
                    color:  var(--primary-color);
                  };
                  }
                }
              }
            }
          }

          &:hover {
            .sub_menu_sect {
              top: 7px;
              visibility: visible;
              opacity: 1;
              z-index: 99;
            }
          }
        }
      }
    }
  }

  .hermes_menu_btns {
    display: flex;
    align-items: center;
    justify-content: right;
    align-items: center;
    min-width: 284px;
    button {
      color: #ffffff;
      text-transform: uppercase;
      font-family: "Bakbak One";
      font-weight: 400;
      font-size: 16px;
    }

    .menu_btn {
      display: none;
      border: none;
      background: transparent;
      cursor: pointer;
      svg {
        font-size: 40px;
      }
    }

    .connect_btn {
      height: 50px;
      min-width: 150px;
      border: none;
      background: var(--primary-color);

      svg {
        font-size: 20px;
      }
    }
  }

  @media (max-width: 1024px) {
    .hermes_menu_list {
      margin-right: 20px;
    }
  }
  @media (max-width: 991px) {
    .hermes_menu_right_sect {
      justify-content: end;
    }
    .hermes_menu_btns {
      justify-content: end;
      .menu_btn {
        display: block;
      }
    }

    .hermes_menu_btns {
    }
    .hermes_menu_list {
      display: none;
      visibility: hidden;
      opacity: 0;
    }
  }

  @media (max-width: 667px) {
    .hermes_menu_btns {
      .btn-mint {
        display: none;
      }

      .menu_btn {
        svg {
          font-size: 30px;
        }
      }
    }
  }

  @media (max-width: 540px) {
    .hermes_menu_left_sect {
      width: 180px;
      .logo {
        img {
          width: 100px;
        }
      }
    }

    .hermes_menu_right_sect {
      width: 50%;
      .hermes_menu_right_sect {
        width: 50%;
      }
    }
  }
`;

const StyledLogo = styled(LogoSVG)`
  path {
    stroke: ${(props) => props.variant || "var(--primary-color)"};
    fill: ${(props) => props.variant || "var(--primary-color)"};
  }
`;

export { NavWrapper, StyledLogo };
